<div class="p-7" (click)="true">

  <!-- HEADER -->
  <div class="flex justify-between items-start mb-6 flex-wrap gap-4">
    <div>
      <h1 class="text-[1.75rem] font-bold text-gray-900 dark:text-white leading-tight">Formularios de marketing</h1>
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
        {{ activeTab === 'manage' ? (globalTotalElements + ' formularios') : (activeTab === 'analyze' ? 'Panel de analítica' : 'Estado del sistema') }}
      </p>
    </div>
    <div class="flex items-center gap-3">
      <button
        class="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-lg text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
        routerLink="/marketing-forms/plantillas"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"/></svg>
        Plantillas
      </button>
      <button
        *appHasPermission="'forms:create'"
        (click)="openCreateModal()"
        class="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-lg text-sm font-semibold text-white bg-brand-500 hover:bg-brand-600 transition-colors"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v14M5 12h14"/></svg>
        Crear formulario
      </button>
    </div>
  </div>

  <!-- TABS -->
  <div class="flex gap-1 border-b border-gray-200 dark:border-gray-700 mb-5">
    @for (tab of tabs; track tab.id) {
      <button
        (click)="setTab(tab.id)"
        class="px-5 py-3 text-sm font-medium transition-colors bg-transparent border-0 border-b-2 -mb-px"
        [class.text-gray-900]="activeTab === tab.id"
        [class.dark:text-white]="activeTab === tab.id"
        [class.border-gray-900]="activeTab === tab.id"
        [class.dark:border-white]="activeTab === tab.id"
        [class.font-semibold]="activeTab === tab.id"
        [class.text-gray-500]="activeTab !== tab.id"
        [class.dark:text-gray-400]="activeTab !== tab.id"
        [class.border-transparent]="activeTab !== tab.id"
      >{{ tab.label }}</button>
    }
  </div>

  <!-- ── ADMINISTRAR ──────────────────────────────────────────────────────── -->
  @if (activeTab === 'manage') {

    <!-- Filter chips + búsqueda -->
    <div class="flex flex-wrap justify-between items-center gap-3 mb-5">
      <div class="flex flex-wrap gap-2">
        @for (chip of filterChips; track chip.value){
          <button
            (click)="setFilter(chip.value)"
            class="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm font-medium transition-colors"
            [class.bg-brand-500]="currentFilter === chip.value"
            [class.text-white]="currentFilter === chip.value"
            [class.dark:bg-white]="currentFilter === chip.value"
            [class.dark:text-gray-900]="currentFilter === chip.value"
            [class.bg-white]="currentFilter !== chip.value"
            [class.text-gray-600]="currentFilter !== chip.value"
            [class.dark:bg-gray-800]="currentFilter !== chip.value"
            [class.dark:text-gray-300]="currentFilter !== chip.value"
            [class.border]="currentFilter !== chip.value"
            [class.border-gray-300]="currentFilter !== chip.value"
            [class.dark:border-gray-600]="currentFilter !== chip.value"
            [class.hover:border-gray-400]="currentFilter !== chip.value"
          >
            @if (currentFilter === chip.value) {
              <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
            }
            {{ chip.label }}
          </button>
        }
      </div>

      <!-- Búsqueda -->
      <div class="flex items-center gap-2 px-3.5 py-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg min-w-[260px] max-w-sm">
        <svg class="w-4 h-4 text-gray-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>
        <input
          type="text"
          placeholder="Buscar formularios..."
          [(ngModel)]="searchTerm"
          (input)="onSearchInput()"
          class="flex-1 text-sm bg-transparent border-none outline-none text-gray-700 dark:text-white placeholder-gray-400"
        />
      </div>
    </div>

    <!-- Métricas -->
    <app-metrics-bar [metrics]="metrics" [loading]="loadingForms" />

    <!-- Tabla -->
    <app-forms-table
      [forms]="forms"
      [loading]="loadingForms"
      [totalElements]="globalTotalElements"
      [totalPages]="globalTotalPages"
      [currentPage]="globalPage"
      [pageSize]="pageSize"
      [pageSizeOptions]="PAGE_SIZE_OPTIONS"
      (pageChange)="cambiarPagina($event)"
      (pageSizeChange)="changePageSize($event)"
      (openDetail)="onOpenDetail($event)"
      (openEditor)="onOpenEditor($event)"
      (openSubmissions)="onOpenSubmissions($event)"
      (deleteForms)="onDeleteForms($event)"
      (duplicateForm)="onDuplicateForm($event)"
      (statusAction)="onStatusAction($event)"
    />
  }

  <!-- ── ANALIZAR ─────────────────────────────────────────────────────────── -->
  @if (activeTab === 'analyze') {
    @if (forms.length === 0) {
      <div class="flex flex-col items-center justify-center py-24 gap-3 text-center">
        <svg class="w-12 h-12 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"/></svg>
        <p class="text-base font-medium text-gray-500 dark:text-gray-400">Sin formularios para analizar</p>
        <p class="text-sm text-gray-400 dark:text-gray-500">Crea un formulario para ver sus métricas aquí.</p>
      </div>
    } @else {
      <app-analytics-dashboard [forms]="forms" />
    }
  }

</div>

<!-- Modal de creación -->
<app-form-modal
  [isOpen]="isModalOpen"
  [loading]="savingForm"
  (closeModal)="isModalOpen = false"
  (create)="onCreateForm($event)"
  (createFromTemplate)="onCreateFromTemplate($event)"
/>

<!-- Modal de detalle -->
<app-form-detail-modal
  [isOpen]="detailModalOpen"
  [form]="selectedForm"
  (close)="onCloseDetail()"
  (edit)="onOpenEditor($event)"
  (updated)="loadForms()"
/>
